import * as React from 'react'

import cn from 'classnames/bind'

import styles from './index.module.css'

const cx = cn.bind(styles)
interface Props {
  inlineSearch: React.ReactNode
  filters?: React.ReactNode
  topBorder?: boolean
  noBorder?: boolean
  noPadding?: boolean
}

// TODO: Move to design-system or deprecate this since it belongs to table
const SearchWithFilter = ({
  inlineSearch,
  filters,
  topBorder = false,
  noBorder = false,
  noPadding = false,
}: Props) => {
  return (
    <div
      className={cx('search', {
        topBorder,
        noBorder,
        noPadding,
      })}
    >
      {!!filters && <div className={styles.filtersContainer}>{filters}</div>}
      <div className={styles.searchContainer}>{inlineSearch}</div>
    </div>
  )
}

export default SearchWithFilter
